module.exports = __webpack_public_path__ + "img/4.a3a979f.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/theme/assets/common/img/temp/login/4.jpg
// module id = ./assets/theme/assets/common/img/temp/login/4.jpg
// module chunks = 152